var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexOfText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 19,
    rx: 2.5,
    stroke: "#1D6295"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6253 8.24996C14.7863 8.24996 14.917 8.38063 14.917 8.54163L14.917 15.25C14.917 15.8934 14.3937 16.4166 13.7503 16.4166C13.1069 16.4166 12.5837 15.8934 12.5837 15.25L12.5837 9.12496C12.5837 8.96396 12.7143 8.83329 12.8753 8.83329C13.0363 8.83329 13.167 8.96396 13.167 9.12496L13.167 15.25C13.167 15.572 13.4289 15.8333 13.7503 15.8333C14.0717 15.8333 14.3337 15.572 14.3337 15.25L14.3337 8.54163C14.3337 8.38063 14.4643 8.24996 14.6253 8.24996Z",
    fill: "#1D6295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1253 8.83329C11.2863 8.83329 11.417 8.96396 11.417 9.12496L11.417 11.75C11.417 12.072 11.6789 12.3333 12.0003 12.3333C12.3217 12.3333 12.5837 12.072 12.5837 11.75C12.5837 11.589 12.7143 11.4583 12.8753 11.4583C13.0363 11.4583 13.167 11.589 13.167 11.75C13.167 12.3934 12.6437 12.9166 12.0003 12.9166C11.3569 12.9166 10.8337 12.3934 10.8337 11.75L10.8337 9.12496C10.8337 8.96396 10.9643 8.83329 11.1253 8.83329Z",
    fill: "#1D6295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37533 8.83325C9.53633 8.83325 9.667 8.96392 9.667 9.12492L9.667 11.1666C9.667 11.4886 9.92891 11.7499 10.2503 11.7499C10.5717 11.7499 10.8337 11.4886 10.8337 11.1666C10.8337 11.0056 10.9643 10.8749 11.1253 10.8749C11.2863 10.8749 11.417 11.0056 11.417 11.1666C11.417 11.81 10.8937 12.3333 10.2503 12.3333C9.60692 12.3333 9.08367 11.81 9.08367 11.1666L9.08367 9.12492C9.08367 8.96392 9.21433 8.83325 9.37533 8.83325Z",
    fill: "#1D6295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.95866 3L13.3344 3C14.2438 3 15.0751 3.46025 15.5581 4.23025L18.2315 8.49325C18.2327 8.49558 18.2338 8.49733 18.235 8.49908C18.354 8.6805 18.417 8.89692 18.417 9.125C18.417 9.76842 17.8937 10.2917 17.2503 10.2917C17.0357 10.2917 16.8297 10.2351 16.6547 10.1277C16.6501 10.1254 16.6454 10.1225 16.6413 10.1196L14.4731 8.79017C14.336 8.70617 14.2922 8.5265 14.3768 8.38883C14.4608 8.25233 14.6417 8.20858 14.7782 8.29317L16.9336 9.615C16.94 9.6185 16.9458 9.622 16.9522 9.62608C17.0368 9.67975 17.1401 9.70833 17.2503 9.70833C17.5717 9.70833 17.8337 9.447 17.8337 9.125C17.8337 9.0165 17.8051 8.91208 17.7532 8.8275C17.7502 8.82342 17.7479 8.81933 17.745 8.81525L15.064 4.54C14.6883 3.94092 14.042 3.58333 13.3344 3.58333L9.95866 3.58333C8.83282 3.58333 7.91699 4.49917 7.91699 5.625L7.91699 10.5833C7.91699 10.9053 8.17891 11.1667 8.50032 11.1667C8.82174 11.1667 9.08366 10.9053 9.08366 10.5833C9.08366 10.4223 9.21432 10.2917 9.37532 10.2917C9.53632 10.2917 9.66699 10.4223 9.66699 10.5833C9.66699 11.2267 9.14374 11.75 8.50032 11.75C7.85691 11.75 7.33366 11.2267 7.33366 10.5833L7.33366 5.625C7.33366 4.17775 8.51141 3 9.95866 3Z",
    fill: "#1D6295"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(19 17) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexOfText);
export default __webpack_public_path__ + "static/media/index_of_text.e656d1537e55850cfcaec7ffb66abee6.svg";
export { ForwardRef as ReactComponent };